export default __webpack_public_path__ + "static/media/wallet.f068d7e4.svg";